// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3987k","productName":"Table_productName__1BQYT"};